<template>
  <div v-if="hasData">
    <div v-for="shift_id in shifts" class="mb-5">

      <h3 v-if="needShowShiftHeader(shift_id)">
        <span>{{ getShiftName(shift_id) }}:</span>
      </h3>
      <div v-if="tasks[shift_id] && tasks[shift_id].length" class="group-header mb-2">Задачи:</div>
      <transition-group v-if="tasks[shift_id] && tasks[shift_id].length" class="list" name="animation-sortable" tag="div">
        <task-block v-for="v in tasks[shift_id]" :key="`task-${v.id}`" :v="v" :selectedTasks="selectedTasks" @selectedTasksUpdater="selectedTasksUpdater" />
      </transition-group>
      <div v-if="params[shift_id] && params[shift_id].length" class="group-header mb-2">Параметры:</div>
      <transition-group v-if="params[shift_id] && params[shift_id].length" class="list" name="animation-sortable" tag="div">
        <param-block v-for="v in params[shift_id]" :key="`param-${v.id}`" :v="v" :selectedParams="selectedParams" @selectedParamsUpdater="selectedParamsUpdater" />
      </transition-group>

    </div>
  </div>
  <div v-else>
    <info-block label="Видимо вы всё сделали.<br>Отличная работа!" icon="bi-emoji-sunglasses-fill" css-classes="text-secondary" class="pt-5 pb-5" />
  </div>
</template>

<script>
import EnvConfig from "@/env";
import nodeList from "@/mixins/nodeList";
import { TaskModel } from "@/models/TaskModel";
import { ParamModel } from "@/models/ParamModel";
import TaskBlock from "@/components/TaskBlock";
import ParamBlock from "@/components/ParamBlock";

export default {
  components: {
    TaskBlock,
    ParamBlock,
  },
  mixins: [
    nodeList,
  ],
  data() {
    return {
      PLATFORM: EnvConfig.PLATFORM,
      selectedTasks: [],
      selectedParams: [],
    }
  },
  computed: {
    _tasks: {
      cache: false,
      get: () => new TaskModel().getList(),
    },
    tasks: {
      cache: false,
      get() {
        return this.sortedAndFilteredList(this._tasks);
      }
    },
    _params: {
      cache: false,
      get: () => new ParamModel().getList(),
    },
    params: {
      cache: false,
      get() {
        return this.sortedAndFilteredList(this._params);
      }
    },
    shifts() {
      const array = Object.assign([], Object.keys(this.tasks), Object.keys(this.params));
      return [...new Set(array)];
    },
    hasData() {
      return Object.keys(this.tasks).length || Object.keys(this.params).length;
    },
  },
  methods: {
    needShowShiftHeader(shift_id) {
      return this.tasks[shift_id] && this.tasks[shift_id].length
          || this.params[shift_id] && this.params[shift_id].length;
    },
    selectedTasksUpdater(val) {
      this.selectedTasks = val;
    },
    selectedParamsUpdater(val) {
      this.selectedParams = val;
    },
  },
}
</script>

<style lang="scss" scoped>
.group-header {
  font-size: 15px;
  background: #222;
  color: #FFF !important;
  display: inline-block;
  padding: 0 13px;
  border-radius: 15px;
}
</style>